import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityService } from '../../services/identity.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-salesforce-auth',
  template: '<p>Authenticating with Salesforce...</p>',
})
export class SalesforceAuthComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private identityService: IdentityService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    this.handleAuthentication();
  }

  private handleAuthentication() {
    this.route.queryParams.subscribe((params) => {
      if (params['code']) {
        this.authenticateWithBackend(params['code']);
      } else {
        this.redirectToSalesforce();
      }
    });
  }

  private redirectToSalesforce() {
    this.identityService.initiateSalesforceLogin().subscribe({
      next: (response) => {
        this.document.location.href = response.loginUrl;
      },
      error: (err) => console.error("Error calling salesforce-login:", err),
    });
  }

  private authenticateWithBackend(code: string) {
    this.identityService.authenticateSalesforceUser(code).subscribe({
      next: () => this.router.navigate(['/dashboard']),
      error: (err) => {
        console.error("Error during Salesforce authentication:", err);
        this.router.navigate(['/error']);
      },
    });
  }
}
